import { FaInstagram, FaFacebook } from "react-icons/fa";
import { SiSpotify, SiApplepodcasts } from "react-icons/si";

const QUICK_LINKS = [
  { label: "Selections", href: "#selections" },
  { label: "Schedule", href: "#schedule" },
  { label: "Tickets", href: "#tickets" },
  { label: "Gallery", href: "#gallery" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

const handleNavClick = (href: string) => {
  const id = href.replace("#", "");
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: "#050508",
        borderTop: "1px solid rgba(255,255,255,0.06)",
        padding: "clamp(48px,8vw,80px) clamp(20px,5vw,80px) 32px",
      }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
        {/* Top grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1.5fr 1fr 1fr",
            gap: "48px",
            paddingBottom: "48px",
            borderBottom: "1px solid rgba(255,255,255,0.06)",
            marginBottom: "32px",
          }}
          className="footer-grid"
        >
          {/* Brand column */}
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "20px",
              }}
            >
              <img
                src="https://c3store.nyc3.digitaloceanspaces.com/mwff/midwestfearfestlogo26.png"
                alt="Midwest Fear Fest"
                style={{ height: "122px", width: "auto" }}
              />
            </div>
            <p
              style={{
                fontSize: "0.85rem",
                lineHeight: "1.7",
                color: "rgba(136,136,153,0.8)",
                maxWidth: "280px",
                marginBottom: "24px",
              }}
            >
              Fear Looks Better on the Big Screen. An annual celebration of
              independent short films that connects filmmakers and film lovers in Indianapolis.
            </p>

            {/* Social icons */}
            <div style={{ display: "flex", gap: "10px" }}>
              {[
                {
                  icon: <FaInstagram />,
                  href: "https://instagram.com/midwestfearfest",
                  label: "Instagram",
                },
                {
                  icon: <FaFacebook />,
                  href: "https://facebook.com/midwestfearfest",
                  label: "Facebook",
                },
                {
                  icon: <SiSpotify />,
                  href: "https://open.spotify.com/show/1YrHOAOWCzoowFEcrh6wUm",
                  label: "Spotify Podcast",
                },
                {
                  icon: <SiApplepodcasts />,
                  href: "https://podcasts.apple.com/us/podcast/midwest-fear-fest-behind-the-screams/id6808319109",
                  label: "Apple Podcasts",
                },
              ].map(({ icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  style={{
                    width: "38px",
                    height: "38px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "8px",
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    color: "rgba(136,136,153,0.8)",
                    fontSize: "0.95rem",
                    transition: "all 0.2s ease",
                    textDecoration: "none",
                  }}
                  onMouseEnter={(e) => {
                    const el = e.currentTarget as HTMLAnchorElement;
                    el.style.background = "rgba(204,0,0,0.15)";
                    el.style.borderColor = "rgba(204,0,0,0.3)";
                    el.style.color = "#cc0000";
                  }}
                  onMouseLeave={(e) => {
                    const el = e.currentTarget as HTMLAnchorElement;
                    el.style.background = "rgba(255,255,255,0.05)";
                    el.style.borderColor = "rgba(255,255,255,0.08)";
                    el.style.color = "rgba(136,136,153,0.8)";
                  }}
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <div
              style={{
                fontFamily: '"Bebas Neue", cursive',
                fontSize: "0.75rem",
                letterSpacing: "0.25em",
                color: "#888899",
                marginBottom: "20px",
                textTransform: "uppercase",
              }}
            >
              Quick Links
            </div>
            <ul
              style={{
                listStyle: "none",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    style={{
                      fontSize: "0.875rem",
                      color: "rgba(136,136,153,0.8)",
                      textDecoration: "none",
                      transition: "color 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      ((e.currentTarget as HTMLAnchorElement).style.color =
                        "#e8e8e8")
                    }
                    onMouseLeave={(e) =>
                      ((e.currentTarget as HTMLAnchorElement).style.color =
                        "rgba(136,136,153,0.8)")
                    }
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Event Info */}
          <div>
            <div
              style={{
                fontFamily: '"Bebas Neue", cursive',
                fontSize: "0.75rem",
                letterSpacing: "0.25em",
                color: "#888899",
                marginBottom: "20px",
                textTransform: "uppercase",
              }}
            >
              Event Info
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "12px" }}
            >
              {[
                { label: "Date", value: "October 3, 2026" },
                { label: "Venue", value: "Kan-Kan Cinema & Brasserie" },
                {
                  label: "Address",
                  value: "1258 Windsor St, Indianapolis, IN 46203",
                },
                { label: "Email", value: "midwestfearfest@gmail.com" },
              ].map(({ label, value }) => (
                <div key={label}>
                  <div
                    style={{
                      fontSize: "0.65rem",
                      letterSpacing: "0.15em",
                      color: "#cc0000",
                      textTransform: "uppercase",
                      fontFamily: '"Bebas Neue", cursive',
                      marginBottom: "2px",
                    }}
                  >
                    {label}
                  </div>
                  <div
                    style={{
                      fontSize: "0.82rem",
                      color: "rgba(136,136,153,0.8)",
                      lineHeight: 1.4,
                    }}
                  >
                    {value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="footer-bottom"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <p style={{ fontSize: "0.78rem", color: "rgba(136,136,153,0.55)" }}>
            © {year} Midwest Fear Fest. All rights reserved.
          </p>
          <p style={{ fontSize: "0.72rem", color: "rgba(136,136,153,0.35)" }}>
            Powered by{" "}
            <a
              href="https://circlecitycoders.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "rgba(136,136,153,0.5)", textDecoration: "none" }}
            >
              Circle City Coders
            </a>
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            text-align: center;
          }
          .footer-grid > div {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .footer-grid ul {
            align-items: center;
          }
          .footer-bottom {
            flex-direction: column !important;
            align-items: center !important;
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
}
